(function(){
  var ROLE_CLASSES = ["role-active","role-near-left","role-near-right","role-far-left","role-far-right","role-edge-left","role-edge-right","role-hidden"];
  function initCoverflow(root){
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-coverflow-card]"));
    if(!cards.length) return;
    var prevBtn = root.querySelector("[data-coverflow-prev]"), nextBtn = root.querySelector("[data-coverflow-next]");
    var activeIndex = Math.min(2, cards.length - 1);

    function render(){
      cards.forEach(function(card, i){
        var diff = i - activeIndex;
        var d = Math.abs(diff);
        var dir = diff < 0 ? "left" : "right";
        card.classList.remove.apply(card.classList, ROLE_CLASSES);
        if(d === 0) card.classList.add("role-active");
        else if(d === 1) card.classList.add("role-near-" + dir);
        else if(d === 2) card.classList.add("role-far-" + dir);
        else if(d === 3) card.classList.add("role-edge-" + dir);
        else card.classList.add("role-hidden");
      });
      prevBtn && (prevBtn.disabled = activeIndex === 0);
      nextBtn && (nextBtn.disabled = activeIndex === cards.length - 1);
    }

    function goTo(i){
      activeIndex = Math.max(0, Math.min(cards.length - 1, i));
      render();
    }

    cards.forEach(function(card, i){
      card.addEventListener("click", function(e){
        if(i !== activeIndex){ e.preventDefault(); goTo(i); }
      });
      card.addEventListener("mousemove", function(e){
        if(card.classList.contains("role-active")){
          var r = card.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - 0.5;
          var py = (e.clientY - r.top) / r.height - 0.5;
          card.style.setProperty("--tiltX", (py * -5).toFixed(2) + "deg");
          card.style.setProperty("--tiltY", (px * 5).toFixed(2) + "deg");
        }
      });
      card.addEventListener("mouseleave", function(){
        card.style.setProperty("--tiltX", "0deg");
        card.style.setProperty("--tiltY", "0deg");
      });
    });

    prevBtn && prevBtn.addEventListener("click", function(){ goTo(activeIndex - 1); });
    nextBtn && nextBtn.addEventListener("click", function(){ goTo(activeIndex + 1); });

    root.addEventListener("keydown", function(e){
      if(e.key === "ArrowLeft") goTo(activeIndex - 1);
      if(e.key === "ArrowRight") goTo(activeIndex + 1);
    });

    var track = root.querySelector("[data-coverflow-track]"), startX = null;
    track.addEventListener("pointerdown", function(e){ startX = e.clientX; });
    track.addEventListener("pointerup", function(e){
      if(startX !== null){
        var dx = e.clientX - startX;
        if(dx > 50) goTo(activeIndex - 1);
        else if(dx < -50) goTo(activeIndex + 1);
        startX = null;
      }
    });

    var wheelLock = false;
    track.addEventListener("wheel", function(e){
      if(Math.abs(e.deltaY) < 20 || wheelLock) return;
      wheelLock = true;
      goTo(activeIndex + (e.deltaY > 0 ? 1 : -1));
      setTimeout(function(){ wheelLock = false; }, 550);
    }, { passive: true });

    render();
  }

  function init(){
    var roots = document.querySelectorAll("[data-coverflow-root]");
    for(var i = 0; i < roots.length; i++) initCoverflow(roots[i]);
  }

  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init();
  document.addEventListener("shopify:section:load", function(e){
    var root = e.target && e.target.querySelector ? e.target.querySelector("[data-coverflow-root]") : null;
    root && initCoverflow(root);
  });
})();
